import React, { createRef, ReactNode } from 'react';
import { PartialSearchingProps, SearchingProps } from 'modules/Shared/type';
import { PageProps } from 'modules/Layout/type';
import { managePageAction, ManagePageAction } from 'modules/Layout/action';
import { Dispatch } from 'redux';
import { breadcrumbRoutePlantUser } from 'modules/PlantUser/breadcrumbs';
import { connect } from 'react-redux';
import Listing from 'modules/Layout/component/Listing';
import PlantTable from 'modules/PlantUser/container/Table';
import PlantFilter from 'modules/PlantUser/container/Filter';
import PlantPagination from 'modules/PlantUser/container/Pagination';
import PlantPerPage from 'modules/PlantUser/container/PerPage';
import PlantUser from 'modules/PlantUser/model/PlantUser';
import { createSearchingProps } from 'modules/Shared/helper/params';
import {
  setPlantUserListParamsAction,
  SetPlantUserListParamsAction
} from 'modules/PlantUser/action/list';
import { RootState } from 'app/reducer';
import { Button } from 'reactstrap';
import ChangeUserPlantTypeModal from 'modules/PlantUser/component/Modal/ChangeType';

export interface StateProps {
  fetching: boolean;
  type: string;
}

export interface DispatchProps {
  managePage: (payload: PageProps) => ManagePageAction;
  setParams: (payload: PartialSearchingProps) => SetPlantUserListParamsAction;
}

export type Props = StateProps & DispatchProps;

export const mapDispatch = (dispatch: Dispatch): DispatchProps => ({
  managePage: (payload: PageProps) => dispatch(managePageAction(payload)),
  setParams: (payload: PartialSearchingProps) =>
    dispatch(setPlantUserListParamsAction(payload))
});

export const mapState = (state: RootState): StateProps => {
  const { fetching } = state.plantUser.list;
  const { type } = state.layout.page;

  return { fetching, type };
};

export class PlantUserListView extends React.Component<Props> {
  protected searchProps: SearchingProps;
  readonly changeTypeModalRef: React.RefObject<ChangeUserPlantTypeModal>;

  constructor(props: Props) {
    super(props);

    this.searchProps = createSearchingProps(
      window.location.hash,
      PlantUser.getFilterableAttributes(),
      PlantUser.getSortableAttributes()
    );

    this.changeTypeModalRef = createRef();
  }

  componentDidMount(): void {
    const { managePage, setParams } = this.props;

    managePage({
      title: 'User plants',
      breadcrumb: breadcrumbRoutePlantUser()
    });

    setParams(this.searchProps);
  }

  render(): ReactNode {
    const { fetching, type } = this.props;
    const { filter } = this.searchProps;

    if (type) return null;

    return (
      <div className="row plant-user-view">
        <ChangeUserPlantTypeModal ref={this.changeTypeModalRef} />
        <div className="col-12">
          <Listing
            table={<PlantTable />}
            filter={<PlantFilter values={filter} />}
            pagination={<PlantPagination />}
            perPage={<PlantPerPage />}
            loading={fetching}
            buttons={[
              <Button
                key="0"
                color="primary"
                onClick={() => this.changeTypeModalRef.current?.openModal()}
              >
                Change multiple plant types
              </Button>
            ]}
          />
        </div>
      </div>
    );
  }
}

export default connect<StateProps, DispatchProps>(
  mapState,
  mapDispatch
)(PlantUserListView);
